import {
  getInTransitLoads,
  getWarningDialogMessage,
} from "../../../selectors/Myload/selector";
import {
  getLoading,
  getUserMasterData,
  getNetworkStatus,
} from "../../../selectors/selector";
import { connect } from "react-redux";
import React from "react";
import { createStructuredSelector } from "reselect";
import { ExecutionPage } from "../../../web/pages/Execution";
import { getStartTripShipment } from "../../../selectors/carrierAssign/selector";
import { clearWarningDialog } from "../../../actions/myload/action";
import { removeDriverUnassignedLoad } from "../../../actions/DriverAssign/action";

const ExecutionContainer: React.FC<any> = (props: any) => {
  return <ExecutionPage {...props} isMyload={true} />;
};

const mapStateToProps = createStructuredSelector({
  loading: getLoading(),
  loads: getInTransitLoads(),
  userDetails: getUserMasterData(),
  isNetworkAvailable: getNetworkStatus(),
  shipmentToStartTrip: getStartTripShipment(),
  warningDialogMessage: getWarningDialogMessage(),
});

const mapDispatchToProps = (dispatch: Function) => ({
  clearWarningDialogMessage: () => dispatch(clearWarningDialog()),
  removeDriverUnassignedLoad: (loadId: string) =>
    dispatch(removeDriverUnassignedLoad(loadId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ExecutionContainer);
